import Tabs from "@bmi-digital/components/tabs";
import Typography from "@bmi-digital/components/typography";
import { styled } from "@mui/material/styles";
import { LeadBlock } from "@bmi-digital/components";
import AssetsIframe from "../AssetsIframe";

const PREFIX = "ProductLeadBlockStyles";

export const classes = {
  "inline-link": `${PREFIX}-inline-link`
};

export const StyledProductLeadBlock = styled("div")({
  ":global": {
    "[class*='MuiBox-root']": {
      padding: "0px"
    }
  },
  [`.${classes["inline-link"]}`]: {
    paddingTop: "10px",
    color: "#0072b0",
    "&:hover": {
      color: "#005b8c"
    },
    transition: "color ease-out 0.25s"
  }
});

export const StyledProductDescription = styled(Typography)({
  "& > *:first-of-type": {
    marginTop: "0"
  }
});

export const StyledImagesContainer = styled("div")({
  display: "flex",
  flexWrap: "wrap",
  gap: "18px"
});

export const StyledImage = styled("img")(({ theme }) => ({
  height: "100px",
  [theme.breakpoints.down("lg")]: {
    height: "80px"
  }
}));

export const StyledDocumentSpan = styled("span")({
  paddingTop: "10px",
  paddingRight: "10px",
  display: "inline-block"
});

export const StyledTabPanel = styled(Tabs.TabPanel)({
  "&&": {
    padding: "30px 0 0 0"
  }
});

export const StyledProductLeadBlockTitle = styled(Typography)({
  marginBottom: "24px"
});

export const StyledProductLeadTabIFrame = styled(AssetsIframe)(({ theme }) => ({
  height: "600px",
  [theme.breakpoints.up("lg")]: {
    height: "800px"
  }
}));

export const StyledLeadBlockContent = styled(LeadBlock.Content)({
  padding: 0
});

export const StyledLeadBlockCard = styled(LeadBlock.Card)(({ theme }) => ({
  padding: "16px 0 24px 0",
  [theme.breakpoints.up("xl")]: {
    padding: "0 0 0 24px"
  }
}));

export const StyledLeadBlock = styled(LeadBlock)({
  margin: 0,
  padding: 0
});
